// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"93":"f135f63a","334":"d46cdbca"}[chunkId] + ".js";
};